import { render, staticRenderFns } from "./selfaudit.vue?vue&type=template&id=9839a322&scoped=true&"
import script from "./selfaudit.vue?vue&type=script&lang=js&"
export * from "./selfaudit.vue?vue&type=script&lang=js&"
import style0 from "./selfaudit.vue?vue&type=style&index=0&id=9839a322&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9839a322",
  null
  
)

export default component.exports